module.exports = __webpack_public_path__ + "static/media/linehaulTruck.c5c1a15f.svg";